import React from 'react'
import { faAdd, faTrash } from '@fortawesome/free-solid-svg-icons'
import {
  DcButton,
  PixelCurrency,
  PixelFactoryContext,
  PixelIcon,
  PixelText,
} from 'pixel-base'
import styled from 'styled-components'

import {
  deleteDiscountLine,
  deleteInvoiceDiscountLine,
} from 'utils/api-routes.util'

import AddDiscountLines from './subComponents/AddDiscountLines'
import { IPixelFactory, OrderDetail } from '../../../../../decl.d'

interface IProps {
  details: OrderDetail
  detailID: number
  setDetails: (details: OrderDetail) => void
  newOrder: boolean
  newOrderData: OrderDetail
  setNewOrderData: (newOrderData: OrderDetail) => void
  isItInvoice: boolean
  newInvoice: boolean
}
const AddDiscount = (props: IProps) => {
  const { showPageLoader, hidePageLoader, showSuccess, pixelConfirm } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const {
    details,
    detailID,
    setDetails,
    newOrder,
    newOrderData,
    setNewOrderData,
    isItInvoice,
  } = props

  const [discountLine, setDiscountLine] = React.useState<any>([])
  const [addAble, setAddAble] = React.useState(false)
  const handleDeleteDiscountLine = (detailID, item_id, temp_id) => {
    if (newOrder === true) {
      setNewOrderData({
        ...newOrderData,
        discounts: newOrderData?.discounts?.filter(
          (key, index) => index !== temp_id,
        ),
      })
    } else {
      pixelConfirm({
        title: 'Delete Discount Line',
        message:
          'Are you sure? you want to delete this Discount, This action cannot be undone.',
        onConfirm: () => {
          if (isItInvoice) {
            showPageLoader()
            deleteInvoiceDiscountLine(detailID, item_id).subscribe(
              (res: any) => {
                hidePageLoader()
                if (res.response.data) {
                  showSuccess('Successfully Deleted')
                  setDetails(res.response.data)
                }
              },
            )
          } else {
            showPageLoader()
            deleteDiscountLine(detailID, item_id).subscribe((res: any) => {
              hidePageLoader()
              if (res.response.data) {
                showSuccess('Successfully Deleted')
                setDetails(res.response.data)
              }
            })
          }
        },
      })
    }
  }

  React.useEffect(() => {
    setDiscountLine(details?.discount_lines)
  }, [details])
  return (
    <Container>
      <InnerSection>
        <SectionHeader>
          <PixelText
            textSize="16px"
            color="rgba(0, 0, 0, 0.84)"
            style={{ fontWeight: '600', padding: '10px' }}
          >
            Discount Line
          </PixelText>
          {newOrder ? (
            // ----------------- new order -----------------
            <>
              {!addAble ? (
                <ADDDiscountLines>
                  <AddDiscountLines
                    newInvoice={props.newInvoice}
                    discountLine={discountLine}
                    detailID={detailID}
                    setDetails={setDetails}
                    newOrderData={newOrderData}
                    setNewOrderData={setNewOrderData}
                    newOrder={true}
                    setAddAble={setAddAble}
                    handleClose={() => {
                      setAddAble(true)
                    }}
                  />
                </ADDDiscountLines>
              ) : (
                <HeaderEnd>
                  <DcButton
                    variant="link"
                    size="sm"
                    onClick={() => {
                      setAddAble(false)
                    }}
                  >
                    <PixelIcon showTooltip tooltip={'Add'} icon={faAdd} />
                  </DcButton>
                </HeaderEnd>
              )}
            </>
          ) : (
            <>
              {(details?.is_editable || details?.invoice_status === 'open') && (
                <>
                  {addAble ? (
                    <ADDDiscountLines>
                      <AddDiscountLines
                        discountLine={discountLine}
                        detailID={detailID}
                        setDetails={setDetails}
                        newOrderData={newOrderData}
                        setNewOrderData={setNewOrderData}
                        newOrder={newOrder}
                        setAddAble={setAddAble}
                        isItInvoice={isItInvoice}
                        handleClose={(data) => {
                          setAddAble(false)
                          if (data) {
                            setDetails(data)
                          }
                        }}
                      />
                    </ADDDiscountLines>
                  ) : (
                    <HeaderEnd>
                      <DcButton
                        size="sm"
                        variant="link"
                        onClick={() => {
                          setAddAble(true)
                        }}
                      >
                        <PixelIcon showTooltip tooltip={'Add'} icon={faAdd} />
                      </DcButton>
                    </HeaderEnd>
                  )}
                </>
              )}
            </>
          )}
        </SectionHeader>
      </InnerSection>
      {newOrder ? (
        <>
          <InnerSectionContent>
            {newOrderData?.discounts?.length > 0 && (
              <>
                {newOrderData?.discounts?.map((item, index) => {
                  return (
                    <InnerSection key={index}>
                      <PaymentContainer>
                        <DiscountTitle>{item.discount_code}</DiscountTitle>
                        <Amounts>
                          {item?.discount_code === 'percentage' ? (
                            <>{item.amount}%</>
                          ) : (
                            <>
                              <PixelCurrency value={item.amount} />
                            </>
                          )}
                        </Amounts>

                        <Actions>
                          <PixelIcon
                            showTooltip
                            tooltip="Delete"
                            icon={faTrash}
                            color="red"
                            fontSize="1x"
                            onClick={() => {
                              handleDeleteDiscountLine(
                                detailID,
                                item.order_discount_line_id,
                                index,
                              )
                            }}
                          />
                        </Actions>
                      </PaymentContainer>
                    </InnerSection>
                  )
                })}
              </>
            )}
          </InnerSectionContent>
        </>
      ) : (
        <>
          <InnerSectionContent>
            {discountLine?.length > 0 && (
              <>
                {discountLine?.map((item, index) => {
                  return (
                    <InnerSection key={index}>
                      <PaymentContainer>
                        <DiscountTitle>{item.discount_code}</DiscountTitle>
                        <Amounts>
                          {item?.discount_code === 'percentage' ? (
                            <>{item.amount}%</>
                          ) : (
                            <>
                              <PixelCurrency value={item.amount} />
                            </>
                          )}
                        </Amounts>
                        {details?.invoice_id ? (
                          <>
                            {details?.invoice_status === 'open' && (
                              <Actions>
                                <PixelIcon
                                  showTooltip
                                  tooltip="Delete"
                                  icon={faTrash}
                                  color="red"
                                  fontSize="1x"
                                  onClick={() => {
                                    handleDeleteDiscountLine(
                                      detailID,
                                      item.order_discount_line_id,
                                      item?.temp_id,
                                    )
                                  }}
                                />
                              </Actions>
                            )}
                          </>
                        ) : (
                          <Actions>
                            <PixelIcon
                              showTooltip
                              tooltip="Delete"
                              icon={faTrash}
                              color="red"
                              fontSize="1x"
                              onClick={() => {
                                handleDeleteDiscountLine(
                                  detailID,
                                  item.order_discount_line_id,
                                  item?.temp_id,
                                )
                              }}
                            />
                          </Actions>
                        )}
                      </PaymentContainer>
                    </InnerSection>
                  )
                })}
              </>
            )}
          </InnerSectionContent>
        </>
      )}
    </Container>
  )
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
const InnerSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  border-bottom: 1px solid #e6e6e6;
  width: 100%;
  padding: 10px 0px;
`
const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const InnerSectionContent = styled.div<{ direction?: boolean; gap?: string }>`
  display: flex;
  flex-direction: ${(props) => (props.direction ? 'row' : 'column')};
  gap: ${(props) => props.gap};
`

const PaymentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  align-content: center;
  width: 100%;
  padding: 15px;
`

export const Amounts = styled.div`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.84);
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 35%;
`
export const DiscountTitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.84);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 50%;
`
const HeaderEnd = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 15px;
  /* padding: 10px; */
  margin-right: 15px;
  cursor: pointer;
`
const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 9%;
`
const ADDDiscountLines = styled.div`
  width: 75%;
`
export default AddDiscount
